import { render, staticRenderFns } from "./OnneCardHorizontal.vue?vue&type=template&id=d4e948a2&scoped=true&"
import script from "./OnneCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./OnneCardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./OnneCardHorizontal.vue?vue&type=style&index=0&id=d4e948a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e948a2",
  null
  
)

export default component.exports